import { GetterTree } from 'vuex'
import { IBusinessState, IRootState } from '@/@types'

const getters: GetterTree<IBusinessState, IRootState> = {
  isBusinessUser: state => {
    if (state.businessUser) {
      return !!state.businessUser.account
    }
    return false
  },
  isBusinessPlanExpired: state => {
    if (state.businessUser) {
      return state.businessUser.account?.status === 'expired'
    }
    return false
  },
  getBusinessUser: state => {
    if (state.businessUser) {
      return state.businessUser
    }
    return false
  },
}

export default getters
